import Icon from './icon.vue';
export default Icon;


// WEBPACK FOOTER //
// ./src/components/common/icon/index.js